import React from 'react';
import './RouteSection.css';

const RouteSection = ({
  title = 'Put do restorana',
  description = 'S obzirom da se na dan vjenčanja u Zagrebu održava Antunovski hod mladih, postoji vjerojatnost da će Ilica i pristupne ceste biti zatvorene u periodu u kojem ćemo se zaputiti prema restoranu. U tom slučaju do restorana se može doći i sa strane Sljemena, a jedna od alternativnih ruta je preko Svetog Duha.',
  origin = 'Medpotoki ul. 1, Zagreb',
  destination = 'Dubravkin put 2, Zagreb',
  mapsUrl,
  embedSrc: embedSrcOverride,
}) => {
  const embedSrc =
    embedSrcOverride ||
    `https://maps.google.com/maps?` +
      `saddr=${encodeURIComponent(origin)}` +
      `&daddr=${encodeURIComponent(destination)}` +
      `&hl=hr&output=embed`;

  const openInMapsUrl =
    mapsUrl ||
    `https://www.google.com/maps/dir/?api=1` +
      `&origin=${encodeURIComponent(origin)}` +
      `&destination=${encodeURIComponent(destination)}`;

  return (
    <section className="route-section" aria-labelledby="route-title">
      <div className="section-container route-section__content">
        <h2 id="route-title" className="route-section__title">
          {title}
        </h2>

        <div className="route-section__divider" aria-hidden="true" />

        <p className="route-section__description">{description}</p>

        <div className="route-section__map-wrapper">
          <iframe
            title="Put do restorana"
            src={embedSrc}
            className="route-section__map"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        </div>

        <a
          href={openInMapsUrl}
          className="route-section__open-btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Otvori u Google Maps
        </a>
      </div>
    </section>
  );
};

export default RouteSection;
